const React = require('react');
const {openPopupWindow} = require('../../../../../../../emitters/popup');
const Popup = require('../../../../../../dumb/Popup/C');
const FormWithdrawProcessingStart = require("../components/FormWithdrawProcessingStart");

module.exports = (data, update) => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;

  return () => {
    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Withdrawal Processing Start</div>
          </div>
        )}
      >
        <div className="mt20">Do you want to begin #{data.id} withdrawal processing?</div>
        <FormWithdrawProcessingStart
          data={data}
          update={update}
          close={close}
        />
      </Popup>
    );
  };
});
